import * as React from "react";
const SvgPhone = (props) => /* @__PURE__ */ React.createElement("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props
}, /* @__PURE__ */ React.createElement("path", {
	d: "M11.5 12V2.65625H4.5V12H11.5ZM9.34375 14V13.3438H6.65625V14H9.34375ZM10.6562 0.65625C11.1979 0.65625 11.6667 0.854167 12.0625 1.25C12.4583 1.64583 12.6562 2.11458 12.6562 2.65625V13.3438C12.6562 13.8854 12.4583 14.3542 12.0625 14.75C11.6667 15.1458 11.1979 15.3438 10.6562 15.3438H5.34375C4.80208 15.3438 4.33333 15.1458 3.9375 14.75C3.54167 14.3542 3.34375 13.8854 3.34375 13.3438V2.65625C3.34375 2.11458 3.54167 1.64583 3.9375 1.25C4.33333 0.854167 4.80208 0.65625 5.34375 0.65625H10.6562Z",
	fill: "currentColor"
}));
export default SvgPhone;
